import { CaseAction, CaseActionStatus } from '../domain/case/CaseDomains';

class CaseActionUtil {
  public static normalizeActions(actions: any): CaseAction[] {
    if (actions == null || actions === undefined) {
      return [];
    }

    if (!Array.isArray(actions)) {
      return [];
    }

    if (actions.length === 0) {
      return [];
    }

    const normalizedActions: CaseAction[] = []; 
    for (let i = 0; i < actions.length; i++) {
      const action = actions[i];
      
      if (typeof action === 'string') {
        const trimmedName = action.trim();
        if (trimmedName.length > 0) {
          normalizedActions.push({
            name: trimmedName,
            status: CaseActionStatus.ALL
          });
        }
        continue;
      }

      if (typeof action === 'object' && action !== null) {
        if ('name' in action) {
          const nameValue = action.name;
          
          if (typeof nameValue === 'string' && nameValue.trim().length > 0) {
            let status: CaseActionStatus = CaseActionStatus.ALL;
            
            if ('status' in action && action.status != null) {
              const statusValue = String(action.status).trim().toUpperCase();
              if ([CaseActionStatus.ALL, CaseActionStatus.FRAUD, CaseActionStatus.NOT_FRAUD].includes(statusValue as CaseActionStatus)) {
                status = statusValue as CaseActionStatus;
              }
            }
            
            normalizedActions.push({
              name: nameValue.trim(),
              status: status
            });
            continue;
          }
          continue;
        }
        
        continue;
      }

      try {
        const strValue = String(action).trim();
        if (strValue.length > 0 && 
            strValue !== 'undefined' && 
            strValue !== 'null' && 
            strValue !== '[object Object]') {
          normalizedActions.push({
            name: strValue,
            status: CaseActionStatus.ALL
          });
        }
      } catch (e) {
        continue;
      }
    }

    return normalizedActions;
  }

  public static normalizeCaseSettingsActions(caseSettings: any): any {
    if (!caseSettings || typeof caseSettings !== 'object') {
      return caseSettings;
    }

    const normalized = { ...caseSettings };
  
    if ('actions' in normalized) {
      normalized.actions = this.normalizeActions(normalized.actions);
    } else {
      normalized.actions = [];
    }

    if (!Array.isArray(normalized.bulkCloseRestrictedUsers)) {
      normalized.bulkCloseRestrictedUsers = [];
    }

    return normalized;
  }
}

export default CaseActionUtil;

